// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__(__webpack_require__.s = "./node_modules/@pmmmwh/react-refresh-webpack-plugin/client/ReactRefreshEntry.js");
__webpack_require__(__webpack_require__.s = "./node_modules/webpack-dev-server/client/index.js?protocol=ws%3A&hostname=0.0.0.0&port=3000&pathname=%2Fws&logging=none&reconnect=10");
__webpack_require__(__webpack_require__.s = "./node_modules/webpack/hot/dev-server.js");
var __webpack_exports__ = __webpack_require__(__webpack_require__.s = "./src/index.tsx");
